import React from 'react';
import Alert from 'Components/Alert';
import DescriptionList from 'Components/DescriptionList/DescriptionList';
import DescriptionListItem from 'Components/DescriptionList/DescriptionListItem';
import FieldSet from 'Components/FieldSet';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import { kinds } from 'Helpers/Props';
import { useTdarrUpdateStatus } from '../queries';

export default function Releases() {
  const update = useTdarrUpdateStatus();
  return <PageContent title="Releases"><PageContentBody><FieldSet legend="Updates">
    {update.isError && <Alert kind={kinds.DANGER}>Unable to check for Tdarr updates.</Alert>}
    {update.data && <><Alert kind={update.data.newVersionAvailable ? kinds.WARNING : kinds.SUCCESS}>{update.data.newVersionAvailable ? 'A new Tdarr version is available.' : 'Tdarr is up to date.'}</Alert><DescriptionList>
      <DescriptionListItem title="Installed Version" data={update.data.currentVersion} /><DescriptionListItem title="Available Version" data={update.data.requiredVersion} /><DescriptionListItem title="Update Status" data={update.data.message} />
    </DescriptionList></>}
  </FieldSet></PageContentBody></PageContent>;
}
